import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SmartJobCardModule } from '../../../shared/components/smart-job-card/smart-job-card.module';
import { JobSearchResultsComponent } from './component/job-search-results/job-search-results.component';
import { SearchBarModule } from '@apply4u/shared/components/search/search-bar/search-bar.module';
import { SearchFiltersModule } from '@apply4u/shared/components/search/search-filters/search-filters.module';
import { SmartPaginationModule } from '@apply4u/shared/components/smart-pagination/smart-pagination.module';
import { NoResultModule } from '@apply4u/shared/components/search/no-result/no-result.module';
import { SortSearchModule } from '@apply4u/shared/components/search/sort-search/sort-search.module';
import { SeoContentLinksModule } from './seo-content-links/seo-content-links.module';
import { SmartModalModule } from '@apply4u/shared/components/smart-modal/smart-modal.module';
import { HighlightPipe } from '@apply4u/shared/pipes/highlight.pipe';
import { HighlightsPipe } from '@apply4u/shared/pipes/highlights.pipe';
import { SafeHtmlPipe } from '@apply4u/shared/pipes/safehtml.pipe';
import { JobCardLoaderModule } from '@apply4u/shared/components/job-card-loader/job-card-loader.module';

const routes: Routes = [
  { path: '', component: JobSearchResultsComponent },
]

@NgModule({
  declarations: [
    JobSearchResultsComponent  
  ],
  imports: [
    CommonModule,
    FormsModule,
    HighlightPipe,
    HighlightsPipe,
    SafeHtmlPipe,
    SortSearchModule,   
    SmartJobCardModule,
    SmartPaginationModule,
    SearchBarModule,
    SearchFiltersModule,
    NoResultModule,
    RouterModule.forChild(routes),
    SeoContentLinksModule,
    SmartModalModule,
    JobCardLoaderModule
  ],
  exports: [RouterModule]
})
export class JobSearchModule { }
